// getUserProjectsInfo.ts

import { useFunctionsStore } from '@/store/functions.store';
import { UserProjectsInfoObject } from "@/types/store"

export const getUserProjectsInfo = async (): Promise<UserProjectsInfoObject | null> => {
    const functionsStore = useFunctionsStore();
    try {
        const response = await functionsStore.callFunction<any>({
            function_name: 'usersTsOnCallSwitch',
            function_payload: {
                action: 'get_projects_info',
                payload: {}
            }
        });

        if (response) {
            return response;
        } else {
            console.error("No project info data received");
            return null;
        }
    } catch (error) {
        console.error('Error fetching project information', error);
        return null;
    }
};

